// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
// 挂载到Vue实力上，全局可通过this.$store进行调用
Vue.prototype.$store = store
/* 路由 */
import router from './router'
import 'babel-polyfill'
import Router from 'vue-router'
Vue.use(Router)
// 导入
import store from './store/index.js'
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
/* axios */
import axios from './api'
import api from './api/api'
Vue.prototype.http = axios;
Vue.prototype.api = api;
// 使用ElementUI
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
Vue.use(ElementUI)
/* swiper */
import 'swiper/dist/css/swiper.min.css';

/* 重置样式 */
import './assets/css/reset.min.css'

/* jquery */
import 'jquery'

/* bootstarp */
import './assets/css/bootstrap.min.css'
import './assets/js/bootstrap.min'

/* animate.css */
import 'animate.css'
// edior
import './assets/css/editor.css'
/* 头部组件 */
import Header from './components/Header'
Vue.component(Header.name, Header)
//富文本
import VueQuillEditor from 'vue-quill-editor'
Vue.use(VueQuillEditor);
// require styles 引入样式
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
// import '@/assets/css/editor.css'//中文富文本样式
// import Quill from 'quill'
// import { ImageExtend, QuillWatch } from 'quill-image-extend-module'
// import imageResize from 'quill-image-resize-module'
// Quill.register('modules/ImageExtend', ImageExtend)
// Quill.register('modules/imageResize', imageResize)
/* 尾部组件 */
import Footer from './components/Footer'
Vue.component(Footer.name, Footer)
//全局图片路劲
Vue.prototype.$imgURL = process.env.API_ROOT
/* 回到顶部 */
import GoTop from './components/GoTop'
Vue.component(GoTop.name, GoTop)
/* 面包屑 */
import Bread from './components/Bread'
Vue.component(Bread.name, Bread)
/* 面包屑 */
import Pagination from './components/Pagination'
Vue.component(Pagination.name, Pagination)
/*使用vant */
import Vant from 'vant';
import 'vant/lib/index.css';

import tools from "./assets/js/tools.js";
Vue.prototype.$tools = tools;

Vue.use(Vant);
Vue.config.productionTip = false


router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});


new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
  /* 这句非常重要，否则预渲染将不会启动 */
  mounted() {
    document.dispatchEvent(new Event('render-event'))
  }
})



// WEBPACK FOOTER //
// ./src/main.js